import { createPlotFeature, } from "@plotlibre/core";
import { createLocalProjection } from "@plotlibre/geometry";
export function createLocalTranslation(start, end) {
    const projection = createLocalProjection(start);
    const deltaMeters = projection.project(end);
    return Object.freeze({
        origin: Object.freeze([start[0], start[1]]),
        deltaMeters: Object.freeze({
            x: deltaMeters.x,
            y: deltaMeters.y,
        }),
    });
}
/**
 * Applies one local-metre displacement to every authored control in a feature
 * set. Generated geometry is intentionally excluded and must be regenerated by
 * each feature's PlotDefinition during preflight.
 */
export function translatePlotFeaturesLocal(features, translation) {
    const { x, y } = translation.deltaMeters;
    if (!Number.isFinite(x) || !Number.isFinite(y)) {
        throw new RangeError("Local translation delta must contain finite metres.");
    }
    const projection = createLocalProjection(translation.origin);
    return Object.freeze(features.map((feature) => {
        const controlPoints = feature.controlPoints.map((position) => {
            const local = projection.project(position);
            const translated = projection.unproject({
                x: local.x + x,
                y: local.y + y,
            });
            if (translated[1] < -90 || translated[1] > 90) {
                throw new RangeError(`Local translation moves feature "${feature.id}" outside valid WGS84 latitude bounds.`);
            }
            return translated;
        });
        return createPlotFeature({
            ...feature,
            controlPoints,
            revision: feature.revision + 1,
        });
    }));
}
//# sourceMappingURL=local-translation.js.map